import {instantToMs} from './order.helper';

/**
 * Milliseconds until a pending Pay By Bank order should switch from
 * "confirming" to "waiting for your bank", counted from when the order went
 * pending (jj-order-svc's statusChangedAt) so a customer reopening a payment
 * that has been pending for an hour is not told it is still being confirmed.
 * The Instant may arrive as an ISO string or as epoch seconds; without a usable
 * one the full delay applies. Same rule as apollo-app's pbbPendingSlowDelay.
 */
export const pbbPendingSlowDelay = (statusChangedAt, now, slowMs) => {
  const changedMs = instantToMs(statusChangedAt);
  if (!Number.isFinite(changedMs) || changedMs > now) {
    return slowMs;
  }
  return Math.max(0, slowMs - (now - changedMs));
};

/**
 * Milliseconds until the confirmation page should next re-read a pending Pay
 * By Bank order: the `every` of the last schedule step whose `after` has been
 * reached, counted from when the order went pending. Without a usable
 * statusChangedAt (or one ahead of this clock) the first step applies.
 */
export const pbbPendingPollDelay = (statusChangedAt, now, schedule) => {
  const changedMs = instantToMs(statusChangedAt);
  const pendingFor =
    Number.isFinite(changedMs) && changedMs <= now ? now - changedMs : 0;
  return schedule.reduce(
    (every, step) => (pendingFor >= step.after ? step.every : every),
    schedule[0].every
  );
};
